import { render, staticRenderFns } from "./LabElementForm.vue?vue&type=template&id=14a54ad7"
import script from "./LabElementForm.vue?vue&type=script&lang=js"
export * from "./LabElementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports